// extracted by mini-css-extract-plugin
export default {"wrapper":"homepage_wrapper__ADA++","wrapper-bg":"homepage_wrapper-bg__rpm4U","content":"homepage_content__jre61"};